// extracted by mini-css-extract-plugin
export var dark = "y_tm";
export var darkcookie = "y_tn";
export var tintedcookie = "y_tp";
export var regularcookie = "y_tq";
export var darkbase = "y_tr";
export var tintedbase = "y_ts";
export var regularbase = "y_tt";
export var darkraw = "y_tv";
export var tintedraw = "y_tw";
export var regularraw = "y_tx";
export var darkchick = "y_ty";
export var tintedchick = "y_tz";
export var regularchick = "y_tB";
export var darkherbarium = "y_tC";
export var tintedherbarium = "y_tD";
export var regularherbarium = "y_tF";
export var darkholiday = "y_tG";
export var tintedholiday = "y_tH";
export var regularholiday = "y_tJ";
export var darkoffline = "y_tK";
export var tintedoffline = "y_tL";
export var regularoffline = "y_tM";
export var darkorchid = "y_tN";
export var tintedorchid = "y_tP";
export var regularorchid = "y_tQ";
export var darkpro = "y_tR";
export var tintedpro = "y_tS";
export var regularpro = "y_tT";
export var darkrose = "y_tV";
export var tintedrose = "y_tW";
export var regularrose = "y_tX";
export var darktimes = "y_tY";
export var tintedtimes = "y_tZ";
export var regulartimes = "y_t0";
export var darkwagon = "y_t1";
export var tintedwagon = "y_t2";
export var regularwagon = "y_t3";